import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  View,
  Modal,
  TouchableOpacity,
  TextInput,
  FlatList,
  Text,
  ScrollView,
  ActivityIndicator,
  TouchableHighlight,
  Dimensions,
} from "react-native";
import RoundedBack from "@assets/svg/RoundedBack";
import { placesAutocomplete } from "@services/api";
import debounce from "lodash/debounce";
import { verticalScale, scale } from "../../utils/scale";
import Cross from "../../assets/svg/CrossIcon";
import SearchWhite from "../../assets/svg/SearchWhite";
import Loc from "../../assets/svg/loc";

import t from "@constants/localization";

const PATH = "screens/Location/SearchModal";

import color from "@constants/color";

function SearchModal(props) {
  const [searchStr, setSearchStr] = useState("");
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const searchFieldRef = useRef(null);

  const autoComplete = (searchText) => {
    setSearching(true);
    placesAutocomplete(searchText)
      .then((res) => {
        res?.data?.predictions && setResults(res.data.predictions);
        setSearching(false);
      })
      .catch((err) => {
        setSearching(false);
      });
  };

  const handler = useCallback(debounce(autoComplete, 1000), []);

  const onSearch = (searchText) => {
    setSearchStr(searchText);
    setSearching(true);
    if (searchText !== null && searchText.trim().length > 2) {
      handler(searchText);
    }
    if (searchText !== null && searchText.trim() === "") {
      setSearching(false);
      setResults([]);
    }
  };

  const handleClose = () => {
    setSearchStr("");
    setResults([]);
    setSearching(false);
  };
  const [active, setActive] = useState("false");

  //To handle text size in searchbox
  const windowWidth = Dimensions.get("window").width;

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      style={{ backgroundColor: "#E5E5E5", flex: 1, overflow: "hidden" }}
      visible={props.showSearch}
      onRequestClose={props.onClose}
      onShow={() => {
        if (searchFieldRef && searchFieldRef.current) {
          searchFieldRef.current.focus();
        }
      }}
    >
      <View
        style={{
          flexDirection: "row",
          height: verticalScale(80),
          paddingBottom: verticalScale(10),
          overflow: "hidden",
          alignItems: "center",
          backgroundColor: "#fff",
          alignContent: "center",
          paddingRight: 16,
        }}
      >
        <TouchableOpacity
          onPress={props.onClose}
          style={{ marginTop: verticalScale(20), marginLeft: scale(10) }}
        >
          <RoundedBack />
        </TouchableOpacity>

        <View
          style={{
            flex: 1,
            marginHorizontal: scale(16),
            marginTop: verticalScale(20),
          }}
        >
          <View
            style={{
              flexDirection: "row",
              paddingHorizontal: scale(10),
              alignItems: "center",
              flex: 1,
              borderWidth: 1,
              borderColor: "rgba(0, 0, 0, 0.3)",
              borderRadius: 4,
            }}
          >
            <ScrollView
              contentContainerStyle={{ flexGrow: 1 }}
              keyboardShouldPersistTaps="handled"
            >
              <TextInput
                ref={searchFieldRef}
                onSubmitEditing={props.onClickSearch}
                returnKeyType="search"
                value={searchStr}
                onChangeText={onSearch}
                placeholder={t(`${PATH}/searchLocation`)}
                style={{
                  flex: 1,
                  position: "relative",
                  alignItems: "center",
                  top: 2,
                  padding: 0,
                  margin: 0,
                  fontFamily: "NotoSansDevanagari-Regular",
                  fontSize: windowWidth < 400 ? 12 : 14,
                  lineHeight: 20,
                }}
              />
            </ScrollView>
            {searchStr.length > 0 && (
              <TouchableOpacity onPress={handleClose}>
                {searching ? (
                  <ActivityIndicator color={color.primary} />
                ) : (
                  <Cross />
                )}
              </TouchableOpacity>
            )}
          </View>
        </View>
        <View style={{ paddingBottom: 10 }}>
          <View>
            <TouchableHighlight
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.1)",
                height: 45,
                width: 45,
                borderRadius: 40,
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                top: 13,
              }}
              activeOpacity={1}
              underlayColor={"#E40046"}
              onPress={handleClose}
            >
              <SearchWhite />
            </TouchableHighlight>
          </View>
        </View>
      </View>
      <View
        style={{
          width: "100%",
          height: 1,
          backgroundColor: "rgba(0,0,0,.1)",
        }}
      />
      {searchStr !== null && searchStr.trim().length < 3 && (
        <View>
          <TouchableOpacity
            onPress={props.onCurrentClick}
            style={{
              height: verticalScale(64),
              width: "100%",
              alignItems: "center",
              paddingHorizontal: scale(10),
              flexDirection: "row",
              backgroundColor: "white",
            }}
          >
            <View style={{ height: scale(24), width: scale(24) }}>
              <Loc fill="#E40046" />
            </View>
            <View style={{ flex: 1, marginLeft: scale(10) }}>
              <Text
                style={{
                  color: "#E40046",
                  fontSize: scale(14),
                  fontFamily: "NotoSansDevanagari-SemiBold",
                  marginTop: 5,
                }}
              >
                {t(`${PATH}/useCurrentLocation`)}
              </Text>
              <Text
                style={{
                  color: "rgba(0, 0, 0, 0.56)",
                  fontSize: scale(12),
                }}
              >
                {t(`${PATH}/ifAtHomeUseCurrentLocation`)}
              </Text>
            </View>
          </TouchableOpacity>
        </View>
      )}

      {searching === false &&
        results.length === 0 &&
        searchStr !== null &&
        searchStr.trim().length > 2 && (
          <View>
            <TouchableOpacity
              style={{
                height: verticalScale(64),
                width: "100%",
                alignItems: "center",
                paddingHorizontal: scale(10),
                flexDirection: "row",
                backgroundColor: "white",
              }}
            >
              <View style={{ flex: 1, marginLeft: scale(10) }}>
                <Text
                  style={{
                    color: "rgba(0, 0, 0, 0.56)",
                    fontSize: scale(12),
                    marginTop: 5,
                  }}
                >
                  {t(`${PATH}/we`)}
                  <Text
                    style={{
                      color: "rgba(0, 0, 0, 0.56)",
                      fontSize: scale(12),
                      fontFamily: "NotoSansDevanagari-SemiBold",
                      marginTop: 5,
                    }}
                  >
                    {" "}
                    {searchStr}{" "}
                  </Text>{" "}
                  {t(`${PATH}/noResultsFound`)}
                </Text>
                <Text
                  style={{
                    color: "rgba(0, 0, 0, 0.36)",
                    fontSize: scale(12),
                  }}
                >
                  {t(`${PATH}/changeLocation`)}
                </Text>
              </View>
            </TouchableOpacity>
          </View>
        )}

      <View style={{ flex: 1, backgroundColor: "#E5E5E5" }}>
        <FlatList
          keyboardShouldPersistTaps="handled"
          data={searchStr.length === 0 ? [] : results}
          renderItem={props.renderItem}
          keyExtractor={(item) => item.place_id}
        />
      </View>
    </Modal>
  );
}

export default SearchModal;
